import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import {
  Accordion as ReachAccordion,
  AccordionItem as ReachAccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@reach/accordion';
import '@reach/accordion/styles.css';

function Accordion({ children, heading, headingLevel = 'h3' }) {
  const Heading = headingLevel;
  const [isExpanded, setExpanded] = useState(false);
  return (
    <ReachAccordion collapsible onChange={() => setExpanded((prev) => !prev)}>
      <ReachAccordionItem>
        <Heading>
          <AccordionButton className="underline uppercase">
            {heading}
            <motion.span
              animate={{ rotate: isExpanded ? 90 : 0 }}
              className="inline-block"
            >
              +
            </motion.span>
          </AccordionButton>
        </Heading>
        <AccordionPanel className="focus:outline-none focus:shadow-outline">
          <AnimatePresence>
            {isExpanded && (
              <motion.div
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                  open: { opacity: 1, height: 'auto' },
                  collapsed: { opacity: 0, height: 0 },
                }}
                transition={{ min: 0, max: 100, bounceDamping: 9 }}
                className="mt-4 overflow-y-hidden"
              >
                {children}
              </motion.div>
            )}
          </AnimatePresence>
        </AccordionPanel>
      </ReachAccordionItem>
    </ReachAccordion>
  );
}

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string.isRequired,
  headingLevel: PropTypes.string,
};

export { Accordion };
